export const ERMES_MODULE_OPTIONS = [
  { key: 'crm', label: 'Insights' },
  { key: 'audiences', label: 'Data' },
  { key: 'alice', label: 'Crea' },
  { key: 'activation', label: 'Media' },
  { key: 'funnel', label: 'Mesure' },
  { key: 'ermesLive', label: 'Ermes Live' },
  { key: 'pilotage', label: 'Pilotage' }
];
